import React from "react";
import { Checkbox as DesignSystemCheckbox } from "../../../design-system";
import InfoIcon from "../InfoIcon";
import { typography, textColors } from "../../../design-system/tokens";

export const CheckboxField = ({ value, onChange, label, help, infoText }) => {
  const checkboxLabel = label ? (
    <>
      {label}
      {infoText ? <span className="ml-2 align-middle"><InfoIcon text={infoText} /></span> : null}
    </>
  ) : undefined;

  return (
    <div className="field-wrapper">
      <div className="flex items-start gap-3 py-0.5">
        <DesignSystemCheckbox
          checked={Boolean(value)}
          onChange={(e) => onChange(e.target.checked)}
          label={checkboxLabel}
          labelClassName={`${typography.label} ${textColors.secondary} select-none cursor-pointer`}
        />
      </div>
      {help && <div className={`mt-1.5 ml-7 ${typography.caption} ${textColors.tertiary}`}>{help}</div>}
    </div>
  );
};
